var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M37 9.45a5 5 0 01-3.26 2.29A15.93 15.93 0 1127.79 6a5 5 0 012.15-3.34A19.74 19.74 0 0020 0a20 20 0 1020 20 19.78 19.78 0 00-3-10.55z","key":0}),React.createElement("path",{"d":"M26.59 10.59L20 17.17l-6.59-6.58-2.82 2.82L17.17 20l-6.58 6.59 2.82 2.82L20 22.83l6.59 6.58 2.82-2.82L22.83 20l6.58-6.59-2.82-2.82zM29.76 7.33a3 3 0 002.58 2.47h.37a3 3 0 002.91-2.3 3.27 3.27 0 00.09-.7 3 3 0 00-3-3 3.25 3.25 0 00-.82.12 3 3 0 00-2.18 2.88c0 .178.016.355.05.53z","key":1})]);
}

Close.defaultProps = {"viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = Close;

Close.default = Close;
